<template>
    <div id="landing-page-booth-map">
        <h1 class="title">Mapa</h1>
        <div class="map-container">
            <div class="sponsor-list">
                <div class="sponsor-category-wrapper">
                    <div class="sponsor-category-title">Generalni sponzor</div>
                    <div class="sponsors-in-category">
                        <div v-for="sponsor in sponsors.filter(sponsor => sponsor.boothLocation === 'general')" v-bind:key="sponsor.id" class="sponsor-in-category">
                            <span>G</span>
                            <span>{{sponsor.name}}</span>
                        </div>
                    </div>
                </div>
                <div class="sponsor-category-wrapper">
                    <div class="sponsor-category-title">Zlatni sponzori</div>
                    <div class="sponsors-in-category">
                        <div v-for="sponsor in sponsors.filter(sponsor => sponsor.boothLocation.startsWith('z'))" v-bind:key="sponsor.id" class="sponsor-in-category">
                            <span>{{sponsor.boothLocation.toUpperCase()}}</span>
                            <span>{{sponsor.name}}</span>
                        </div>
                    </div>
                </div>
                <div class="sponsor-category-wrapper">
                    <div class="sponsor-category-title">Srebrni sponzori</div>
                    <div class="sponsors-in-category">
                        <div v-for="sponsor in sponsors.filter(sponsor => sponsor.boothLocation.startsWith('s'))" v-bind:key="sponsor.id" class="sponsor-in-category">
                            <span>{{sponsor.boothLocation.toUpperCase()}}</span>
                            <span>{{sponsor.name === 'Bundesdruckerei' ? 'Maurer Electronics' : sponsor.name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <svg x="0" y="0" width="1286" height="909" viewBox="0 0 1286 909" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                style="display: block;">
                <path d="M0,909.4H1286.2V0H0V909.4Z" class="background" />
                <path d="M377.9,245.4V547.7c0,2.4,2,4.3,4.3,4.3H535.5c2.4,0,4.3,2,4.3,4.4V663c0,2.4,2,4.3,4.3,4.3H988.6c2.4,0,4.3,-1.9,4.3,-4.3V559.9c0,-2.4,2,-4.3,4.4,-4.3H1098c2.4,0,4.3,-1.9,4.3,-4.3V392.6c0,-2.4,-1.9,-4.3,-4.4,-4.3l-100.6,.8c-2.4,0,-4.4,-1.9,-4.4,-4.3l.2,-139.4c0,-2.4,-2,-4.4,-4.4,-4.4H382.2c-2.3,0,-4.3,2,-4.3,4.4Z" class="g1_1" />
                <path d="M431.2,300H399c-2.4,0,-4.4,-1.9,-4.4,-4.3V263.4c0,-2.4,2,-4.3,4.4,-4.3h32.2c2.4,0,4.4,1.9,4.4,4.3v32.3c0,2.4,-2,4.3,-4.4,4.3Z" class="g0_1" />
                <path d="M546.6,453.2H514.4c-2.4,0,-4.4,-2,-4.4,-4.4V416.6c0,-2.4,2,-4.4,4.4,-4.4h32.2c2.4,0,4.4,2,4.4,4.4v32.2c0,2.4,-2,4.4,-4.4,4.4Z" class="g0_1" />
                <path d="M705.2,649.5H673c-2.4,0,-4.4,-2,-4.4,-4.4V612.9c0,-2.4,2,-4.4,4.4,-4.4h32.2c2.4,0,4.4,2,4.4,4.4v32.2c0,2.4,-2,4.4,-4.4,4.4Z" class="g0_1" />
                <path d="M852.9,649.5H820.7c-2.4,0,-4.4,-2,-4.4,-4.4V612.9c0,-2.4,2,-4.4,4.4,-4.4h32.2c2.4,0,4.4,2,4.4,4.4v32.2c0,2.4,-2,4.4,-4.4,4.4Z" class="g0_1" />
                <path d="M1029.3,538H997c-2.4,0,-4.3,-1.9,-4.3,-4.3V501.4c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.4,-1.9,4.3,-4.3,4.3Z" class="g0_1" />
                <path d="M1029.3,448.1H997c-2.4,0,-4.3,-1.9,-4.3,-4.3V411.5c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.4,-1.9,4.3,-4.3,4.3Z" class="g0_1" />
                <path d="M546.6,391.8H514.4c-2.4,0,-4.4,-2,-4.4,-4.3V355.2c0,-2.4,2,-4.3,4.4,-4.3h32.2c2.4,0,4.4,1.9,4.4,4.3v32.3c0,2.3,-2,4.3,-4.4,4.3Z" class="g0_1" />
                <path d="M754.6,300H722.3c-2.4,0,-4.3,-1.9,-4.3,-4.3V263.4c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.3,0,4.3,1.9,4.3,4.3v32.3c0,2.4,-2,4.3,-4.3,4.3Z" class="g0_1" />
                <path d="M815.9,300H783.7c-2.4,0,-4.3,-1.9,-4.3,-4.3V263.4c0,-2.4,1.9,-4.3,4.3,-4.3h32.2c2.4,0,4.4,1.9,4.4,4.3v32.3c0,2.4,-2,4.3,-4.4,4.3Z" class="g0_1" />
                <path d="M877.3,300H845.1c-2.4,0,-4.4,-1.9,-4.4,-4.3V263.4c0,-2.4,2,-4.3,4.4,-4.3h32.2c2.4,0,4.4,1.9,4.4,4.3v32.3c0,2.4,-2,4.3,-4.4,4.3Z" class="g0_1" />
                <path d="M429.5,391.8H397.2c-2.4,0,-4.3,-2,-4.3,-4.3V355.2c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.3,-1.9,4.3,-4.3,4.3Z" class="g0_1" />
                <path d="M429.5,538H397.2c-2.4,0,-4.3,-1.9,-4.3,-4.3V501.4c0,-2.4,1.9,-4.3,4.3,-4.3h32.3c2.4,0,4.3,1.9,4.3,4.3v32.3c0,2.4,-1.9,4.3,-4.3,4.3Z" class="g0_1" />
                <path d="M487.8,538H455.6c-2.4,0,-4.4,-1.9,-4.4,-4.3V501.4c0,-2.4,2,-4.3,4.4,-4.3h32.2c2.4,0,4.4,1.9,4.4,4.3v32.3c0,2.4,-2,4.3,-4.4,4.3Z" class="g0_1" />
                <path d="M546.6,538H514.4c-2.4,0,-4.4,-1.9,-4.4,-4.3V501.4c0,-2.4,2,-4.3,4.4,-4.3h32.2c2.4,0,4.4,1.9,4.4,4.3v32.3c0,2.4,-2,4.3,-4.4,4.3Z" class="g0_1" />
                <text x="407" y="283" class="s1_1">S2</text>
                <path d="M832.1,552.8H694.5c-2.4,0,-4.4,-2,-4.4,-4.3v-137c0,-2.4,2,-4.3,4.4,-4.3H832.1c2.4,0,4.3,1.9,4.3,4.3v137c0,2.3,-1.9,4.3,-4.3,4.3Z" class="g2_1" />
                <path d="M524,331.4H460.4c-2.4,0,-4.4,-2,-4.4,-4.3V263.4c0,-2.4,2,-4.3,4.4,-4.3H524c2.4,0,4.3,1.9,4.3,4.3v63.7c0,2.3,-1.9,4.3,-4.3,4.3Z" class="g3_1" />
                <path d="M693.2,331.4H629.5c-2.4,0,-4.3,-2,-4.3,-4.3V263.4c0,-2.4,1.9,-4.3,4.3,-4.3h63.7c2.4,0,4.3,1.9,4.3,4.3v63.7c0,2.3,-1.9,4.3,-4.3,4.3Z" class="g3_1" />
                <path d="M970.1,331.4H906.5c-2.4,0,-4.4,-2,-4.4,-4.3V263.4c0,-2.4,2,-4.3,4.4,-4.3h63.6c2.4,0,4.3,1.9,4.3,4.3v63.7c0,2.3,-1.9,4.3,-4.3,4.3Z" class="g3_1" />
                <text x="753" y="490" class="s2_1">G</text>
                <text x="401" y="523" dx="0,-0.2,0" class="s1_1">S14</text>
                <text x="460" y="523" dx="0,-0.2,0" class="s1_1">S13</text>
                <text x="677" y="633" dx="0,-0.2,-0.2" class="s1_1">S11</text>
                <text x="825" y="633" dx="0,-0.2,0" class="s1_1">S10</text>
                <text x="1004" y="521" dx="0,-0.2" class="s1_1">S9</text>
                <text x="1004" y="431" class="s1_1">S8</text>
                <text x="853" y="283" class="s1_1">S7</text>
                <text x="929" y="298" class="s1_1">Z3</text>
                <text x="653" y="298" class="s1_1">Z2</text>
                <text x="483" y="298" class="s1_1">Z1</text>
                <text x="791" y="283" class="s1_1">S6</text>
                <text x="730" y="283" class="s1_1">S5</text>
                <text x="405" y="375" dx="0,-0.2" class="s1_1">S1</text>
                <text x="523" y="375" class="s1_1">S3</text>
                <text x="522" y="436" class="s1_1">S4</text>
                <text x="213" y="462" dx="0,0,0,0,0,0,0,-0.8,-0.4,0,0,0" class="other-text">AKREDITACIJE</text>
                <text x="210" y="703" dx="0,0,0,0,0,0,0,0,0,0,0,0,0,-0.2,0,0" class="other-text">SREBRNI SPONZORI</text>
                <text x="210" y="727" dx="0,0,0,-0.8,0,0,0,0,0,0,0,0,-0.2,0,0" class="other-text">ZLATNI SPONZORI</text>
                <text x="210" y="752" dx="0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,-0.2,0" class="other-text">GENERALNI SPONZOR</text>
                <text x="518" y="168" dx="0,-0.7,0,0,0,0,0,0,0,0,-0.1,-0.1,-0.2,-0.3,0" class="other-text">VANJSKI PROSTOR</text>
                <text x="594" y="751" dx="0,-0.2,-0.2,0,0,0,0" class="other-text">DVORANA</text>
                <text x="210" y="665" class="s3_1">Legenda</text>
                <text x="184" y="703" class="s4_1">S</text>
                <text x="184" y="727" class="s4_1">Z</text>
                <text x="184" y="752" class="s4_1">G</text>
                <path d="M645.4,703.3c0,9.6,-7.7,17.3,-17.3,17.3c-9.6,0,-17.4,-7.7,-17.4,-17.3c0,-9.6,7.8,-17.4,17.4,-17.4c9.6,0,17.3,7.8,17.3,17.4Z" class="g2_1" />
                <path d="M359.7,456.5c0,9.6,-7.7,17.3,-17.3,17.3c-9.6,0,-17.4,-7.7,-17.4,-17.3c0,-9.6,7.8,-17.4,17.4,-17.4c9.6,0,17.3,7.8,17.3,17.4Z" class="g2_1" />
                <path d="M595.8,205c0,9.6,-7.7,17.3,-17.3,17.3c-9.6,0,-17.4,-7.7,-17.4,-17.3c0,-9.6,7.8,-17.4,17.4,-17.4c9.6,0,17.3,7.8,17.3,17.4Z" class="g2_1" />
                <text x="518" y="523" dx="0,-0.2,0" class="s1_1">S12</text>
            </svg>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'BoothMap',
        data() {
            return {
                sponsors: []
            }
        },
        created() {
            this.$axios.get(`${this.$API_URL}/companies/all-sponsors`).then(response => {
                this.sponsors = response.data.filter(sponsor => 
                    sponsor.sponsorCategory === 'General' || 
                    sponsor.sponsorCategory === 'Gold' || 
                    sponsor.sponsorCategory === 'Silver')
                    .sort((firstSponsor, secondSponsor) => 
                        parseInt(firstSponsor.boothLocation.substr(1)) < parseInt(secondSponsor.boothLocation.substr(1)) ? -1 : 1);
            });
        }
    }
</script>

<style scoped>
    #landing-page-booth-map {
        padding-left: 12%;
    }

    #landing-page-booth-map h1 {
        font-size: 54px;
        font-weight: 800;
        line-height: 65px;
        margin-top: 150px;
    }

    #landing-page-booth-map svg {
        margin-left: auto;
        margin-right: auto;
    }

    .sponsor-category-title {
        font-size: 18px;
        font-weight: 800;
        line-height: 21px;
        margin-bottom: 10px;
        margin-top: 50px;
    }

    .sponsor-in-category {
        display: flex;
        align-items: center;
    }

    .sponsor-in-category span:first-of-type {
        display: inline-block;
        width: 40px;
        font-size: 14px;
        color: #30cec1;
    }

    .map-container {
        margin-top: -140px;
        display: flex;
        align-items: center;
    }

    .map-container .sponsor-list {
        width: 20%;
    }

    .other-text{
        font-size: 15.28px;
        fill: #193B44;
    }

    .s1_1 {
        font-size: 15.28px;
        fill: #FFFFFF;
    }

    .s2_1{
        font-size: 30.56px;
        fill: #FFFFFF;
    }

    .s3_1{
        font-size: 30.56px;
        fill: #5CC4BC;
    }

    .s4_1{
        font-size: 15.28px;
        fill: #193B44;
    }

    .g1_1{
        fill: lightgray;
        opacity: 0.2;
    }

    .background {
        fill: #FFFFFF;
    }

    .g0_1,
    .g2_1,
    .g3_1 {
        fill: #5CC4BC;
    }

    @media screen and (max-width: 1390px)
    {
        .map-container .sponsor-list {
            width: 30%;
        }
    }

    @media screen and (max-width: 1160px)
    {
        .map-container .sponsor-list {
            width: 35%;
        }
    }

    @media screen and (max-width: 1024px)
    {
        .map-container .sponsor-list {
            display: flex;
            flex-wrap: wrap;
            width: 100%;
        }

        .map-container {
            flex-direction: column;
            margin-top: 20px;
            align-items: flex-start;
        }

        .sponsor-category-wrapper {
            flex-basis: 25%;
        }

        .sponsor-category-wrapper:last-of-type {
            flex-basis: 50%;
        }

        .sponsors-in-category {
            display: flex;
            flex-wrap: wrap;
        }

        .sponsor-category-wrapper:last-of-type .sponsors-in-category .sponsor-in-category {
            flex-basis: 50%;
        }

        #landing-page-booth-map svg {
            width: 100%;
            margin-top: -130px;
            margin-left: -50px;
        }
    }

    @media screen and (max-width: 950px)
    {
        .sponsor-category-wrapper:last-of-type {
            margin-right: 50%;
        }

        .sponsor-category-wrapper:last-of-type .sponsors-in-category .sponsor-in-category {
            flex-basis: 50%;
        }

        #landing-page-booth-map svg {
            width: 100%;
            margin-top: -170px;
            margin-left: -65px;
            margin-bottom: -250px;
        }
    }

    @media screen and (max-width: 850px)
    {
        .sponsor-category-wrapper {
            flex-basis: 35%;
        }

        .sponsor-category-wrapper:last-of-type {
            margin-right: 0;
            flex-basis: 70%;
        }

        #landing-page-booth-map svg {
            margin-top: -190px;
        }
    }

    @media screen and (max-width: 600px)
    {
        .sponsor-category-wrapper {
            flex-basis: 70%;
        }

        .sponsors-in-category {
            flex-direction: column;
        }

        .sponsor-category-wrapper:last-of-type {
            flex-basis: 90%;
        }

        .sponsor-category-wrapper:last-of-type .sponsors-in-category {
            flex-direction: row;
        }

        #landing-page-booth-map svg {
            width: 130%;
            margin-left: -100px;
        }
    }

    @media screen and (max-width: 480px)
    {
        #landing-page-booth-map svg {
            width: 145%;
            margin-left: -105px;
            margin-top: -250px;
        }

        .sponsor-category-wrapper:last-of-type .sponsors-in-category .sponsor-in-category {
            flex-basis: 100%;
        }
    }

    @media screen and (max-width: 400px)
    {
        #landing-page-booth-map svg {
            width: 150%;
            margin-bottom: -400px;
        }
    }

    @media screen and (max-width: 360px)
    {
        #landing-page-booth-map svg {
            width: 155%;
            margin-bottom: -400px;
        }

        #landing-page-booth-map svg {
            margin-left: -105px;
            margin-top: -270px;
        }
    }
</style>